import { render, staticRenderFns } from "./EditViolation.vue?vue&type=template&id=660f4364&"
import script from "./EditViolation.vue?vue&type=script&lang=js&"
export * from "./EditViolation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports